"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionTable = exports.TableContainer = void 0;
var aon_tws_common_ui_1 = require("@aon/aon-tws-common-ui");
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var constants_1 = __importDefault(require("../../constants"));
var contentConstants_1 = __importDefault(require("../../contentConstants"));
var models_1 = require("../../models");
var utilities_1 = require("../../utilities");
var common_1 = require("../common");
var QuestionRow_1 = require("./QuestionRow");
exports.TableContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tmargin: ", ";\n"], ["\n\tmargin: ", ";\n"])), function (props) { return (props.didRemoveToolMenu ? '0px 0' : '40px 0'); });
var ToolMenuButtonGroup = (0, styled_components_1.default)(aon_tws_common_ui_1.ButtonGroup)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\twidth: 100%;\n"], ["\n\twidth: 100%;\n"])));
var FilterSelectWrapper = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tmargin-left: 10px;\n\t@media (min-width: 0) and (max-width: 768px) {\n\t\tmargin-left: 0;\n\t\tmargin-top: 10px;\n\t}\n"], ["\n\tmargin-left: 10px;\n\t@media (min-width: 0) and (max-width: 768px) {\n\t\tmargin-left: 0;\n\t\tmargin-top: 10px;\n\t}\n"])));
var PageTurnOptionsContainer = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tfloat: left;\n"], ["\n\tfloat: left;\n"])));
var QuestionTable = /** @class */ (function (_super) {
    __extends(QuestionTable, _super);
    function QuestionTable(props) {
        var _this = this;
        var _a;
        _this = _super.call(this, props) || this;
        var defaultSortParams = [
            { sortedBy: 'dimensions', sortAsc: 'asc' },
            { sortedBy: 'code', sortAsc: 'asc' },
        ];
        _this.state = {
            filterOptions: [],
            pageRange: _this.props.pageRange || { offset: 0, limit: 25 },
            searchText: '',
            selectedFilterOptions: [],
            selectedMajorFilterOption: (_a = props.selectedMajorFilterOption) !== null && _a !== void 0 ? _a : '',
            showVariations: false,
            sortParams: _this.props.sortParams || defaultSortParams,
        };
        _this.GetFilteredQuestions = _this.GetFilteredQuestions.bind(_this);
        _this.GetPropertySelector = _this.GetPropertySelector.bind(_this);
        _this.GetSortParam = _this.GetSortParam.bind(_this);
        _this.SortOnColumn = _this.SortOnColumn.bind(_this);
        _this.SortQuestions = _this.SortQuestions.bind(_this);
        _this.ToggleShowVariations = _this.ToggleShowVariations.bind(_this);
        _this.UpdatePaging = _this.UpdatePaging.bind(_this);
        _this.UpdateSearch = _this.UpdateSearch.bind(_this);
        _this.UpdateSelectedColumns = _this.UpdateSelectedColumns.bind(_this);
        return _this;
    }
    QuestionTable.GetFilterOptions = function (props) {
        var questions = props.questions;
        if (!questions.length) {
            return [];
        }
        var rogOptions = utilities_1.QuestionFilterHelper.deriveUniqueResponseOptionGroups(questions);
        var tagOptions = utilities_1.QuestionFilterHelper.deriveUniqueTags(questions);
        var templateOptions = utilities_1.QuestionFilterHelper.deriveUniqueQuestionTemplates(questions);
        var languageOptions = utilities_1.QuestionFilterHelper.deriveUniqueCultures(props.availableCultures, props.questions);
        var benchmarkOptions = utilities_1.QuestionFilterHelper.deriveUniqueBenchmarks(props.availableBenchmarks, props.questions);
        return rogOptions.concat(tagOptions).concat(languageOptions).concat(benchmarkOptions).concat(templateOptions);
    };
    QuestionTable.getDerivedStateFromProps = function (props, state) {
        var _a;
        var filterOptions = QuestionTable.GetFilterOptions(props);
        var selectedFilterOptions = state.selectedFilterOptions.filter(function (selectedValue) {
            return filterOptions.some(function (filterOption) { return filterOption.name === selectedValue; });
        });
        var selectedMajorFilterOption = (_a = props.selectedMajorFilterOption) !== null && _a !== void 0 ? _a : '';
        var pageRange = __assign(__assign({}, state.pageRange), { offset: selectedMajorFilterOption === state.selectedMajorFilterOption ? state.pageRange.offset : 0 });
        return { filterOptions: filterOptions, selectedFilterOptions: selectedFilterOptions, pageRange: pageRange, selectedMajorFilterOption: selectedMajorFilterOption };
    };
    QuestionTable.prototype.render = function () {
        var _this = this;
        var _a = this.props, actionsOnAPI = _a.actionsOnAPI, columnHeaderSelectable = _a.columnHeaderSelectable, questions = _a.questions, selectable = _a.selectable, showFilterOption = _a.showFilterOption;
        var filteredQuestions = actionsOnAPI ? questions : this.GetFilteredQuestions();
        var questionTotalCount = actionsOnAPI ? this.props.pageRange && this.props.pageRange.total : filteredQuestions.length;
        var pageRange = __assign(__assign({}, this.state.pageRange), { total: questionTotalCount });
        var selectableColumns = this.props.columns.filter(function (c) { return c.name !== 'isSelected'; });
        var shouldRemovePaging = this.props.shouldRemovePaging;
        var tableQuestions = actionsOnAPI || shouldRemovePaging
            ? filteredQuestions
            : new aon_tws_common_ui_1.PagingHelper().page(filteredQuestions, this.state.pageRange);
        return (React.createElement(React.Fragment, null, this.props.loading ? (React.createElement(common_1.LoadingWrapper, null,
            React.createElement(aon_tws_common_ui_1.Loading, { height: '70px', width: '70px' }))) : (React.createElement(React.Fragment, null,
            !shouldRemovePaging && React.createElement(aon_tws_common_ui_1.PagingOptions, { pageRange: pageRange, updatePageRange: this.UpdatePaging }),
            !this.props.shouldRemoveToolMenu && (React.createElement(aon_tws_common_ui_1.ToolMenu, null,
                React.createElement(aon_tws_common_ui_1.ToolMenuContent, { type: 'right' },
                    React.createElement(aon_tws_common_ui_1.SearchBox, { callbackFunc: this.UpdateSearch, resultsCount: filteredQuestions.length, initialSearchText: this.state.searchText, inputSize: 'sm' })),
                React.createElement(aon_tws_common_ui_1.ToolMenuContent, { type: 'left' },
                    React.createElement(ToolMenuButtonGroup, { type: 'vertical' },
                        React.createElement(aon_tws_common_ui_1.Select, { items: selectableColumns, multiple: true, selectedValues: utilities_1.ColumnHelper.GetSelectedColumnNames(selectableColumns), onApply: this.UpdateSelectedColumns, showCount: true, displayText: contentConstants_1.default.COLUMNPICKER_TITLE, selectWidth: '180px', optionsContainerWidth: '250px', size: 'sm' }),
                        showFilterOption && (React.createElement(FilterSelectWrapper, null,
                            React.createElement(aon_tws_common_ui_1.Select, { items: this.state.filterOptions, selectedValues: this.state.selectedFilterOptions, onApply: function (values) { return _this.setState({ selectedFilterOptions: values }); }, hasGroups: true, multiple: true, showCount: true, size: 'sm', displayText: 'Filter' }))),
                        React.createElement(aon_tws_common_ui_1.Switch, { style: { marginLeft: '10px' }, text: 'Alternate Questions', checked: this.state.showVariations, onChange: function (event) { return _this.ToggleShowVariations(event.target.checked); } }))))),
            React.createElement(exports.TableContainer, { didRemoveToolMenu: this.props.shouldRemoveToolMenu },
                React.createElement(aon_tws_common_ui_1.Table, { responsive: true, selectable: selectable ? selectable.toString() : undefined },
                    React.createElement(aon_tws_common_ui_1.ColumnHeader, { sortedBy: this.state.sortParams[0].sortedBy, sortAsc: this.state.sortParams[0].sortAsc === 'asc', columns: utilities_1.LibraryQuestionColumnHelper.getColumnHeaders(this.props.columns), handleSort: this.SortOnColumn, selectable: columnHeaderSelectable }),
                    React.createElement("tbody", null, 
                    // Map each of the questions.
                    tableQuestions.map(function (question, index) {
                        return (React.createElement(QuestionRow_1.QuestionRow, __assign({}, _this.props, { disabled: _this.IsQuestionRowDisabled(question), hideLanguageModalIcon: _this.props.hideLanguageModalIcon, key: index, question: question, searchText: _this.state.searchText })));
                    }))),
                !filteredQuestions.length && this.state.searchText && React.createElement(common_1.NoSearchResultsMessage, null),
                !shouldRemovePaging && (React.createElement(PageTurnOptionsContainer, null,
                    React.createElement(aon_tws_common_ui_1.PageTurnOptions, { pageRange: pageRange, updatePageRange: this.UpdatePaging }))))))));
    };
    QuestionTable.prototype.SortOnColumn = function (sortedBy, sortAscByDefault) {
        var UpdateSort = this.props.UpdateSort;
        var primarySortParam = this.state.sortParams[0];
        if (primarySortParam.sortedBy === sortedBy) {
            var copy = __spreadArray([], this.state.sortParams, true);
            copy[0] = __assign(__assign({}, primarySortParam), { sortAsc: primarySortParam.sortAsc === 'asc' ? 'desc' : 'asc' });
            this.setState({ sortParams: copy });
        }
        else {
            var sortParams = [this.GetSortParam(sortedBy, sortAscByDefault)];
            // assign default sort direction of the secondary column back to default.
            var col = this.props.columns.find(function (c) { return c.name === primarySortParam.sortedBy; });
            var colDirection = col && col.sortAscByDefault ? col.sortAscByDefault : true;
            sortParams.push(this.GetSortParam(primarySortParam.sortedBy, colDirection));
            this.setState({ sortParams: sortParams });
        }
        if (UpdateSort) {
            UpdateSort(sortedBy, sortAscByDefault);
        }
    };
    QuestionTable.prototype.UpdateSelectedColumns = function (values) {
        var UpdateColumns = this.props.UpdateColumns;
        var columns = utilities_1.ColumnHelper.UpdateSelectedColumns(this.props.columns, values.concat('isSelected'));
        if (UpdateColumns) {
            UpdateColumns(columns);
        }
    };
    QuestionTable.prototype.GetSortParam = function (sortedBy, sortedByAsc) {
        switch (sortedBy) {
            case 'code':
            case 'dimensions':
            case 'isSelected':
            case 'isCustomQuestionSelected':
            case 'isCustomQuestion':
            case 'text':
                return { sortedBy: sortedBy, sortAsc: sortedByAsc ? 'asc' : 'desc' };
            default:
                throw Error('Can not sort on unsupported property: ' + sortedBy);
        }
    };
    QuestionTable.prototype.UpdatePaging = function (pageRange) {
        var UpdatePaging = this.props.UpdatePaging;
        this.setState({ pageRange: pageRange }, function () {
            if (UpdatePaging) {
                UpdatePaging(pageRange);
            }
        });
    };
    QuestionTable.prototype.UpdateSearch = function (searchText) {
        var UpdateSearch = this.props.UpdateSearch;
        this.setState({ searchText: searchText, pageRange: __assign(__assign({}, this.state.pageRange), { offset: 0 }) }, function () {
            if (UpdateSearch) {
                UpdateSearch(searchText);
            }
        });
    };
    QuestionTable.prototype.GetFilteredQuestions = function () {
        var _this = this;
        var questions = __spreadArray([], this.props.questions, true);
        questions = new aon_tws_common_ui_1.SearchHelper()
            .addColumnSelector(function (q) { return q.text; })
            .addColumnSelector(function (q) { return q.code; })
            .addColumnSelector(function (q) { return (q.questionVariations || []).map(function (item) { return item.text; }).join(','); })
            .addColumnSelector(function (q) { return (q.questionVariations || []).map(function (item) { return item.code; }).join(','); })
            .addColumnSelector(function (q) { return (q.dimensionNames || []).join(','); })
            .search(questions, this.state.searchText);
        // filter
        var isSelected = function (prefix, value) {
            return _this.state.selectedFilterOptions.indexOf(prefix + value) > -1;
        };
        if (this.state.selectedFilterOptions.some(function (o) { return o.startsWith(constants_1.default.FILTER_PREFIX_TAG); })) {
            questions = questions.filter(function (q) { return (q.tagNames || []).some(function (t) { return isSelected(constants_1.default.FILTER_PREFIX_TAG, t); }); });
        }
        if (this.state.selectedFilterOptions.some(function (o) { return o.startsWith(constants_1.default.FILTER_PREFIX_ROG); })) {
            questions = questions.filter(function (q) { return q.responseOptionGroup != null && isSelected(constants_1.default.FILTER_PREFIX_ROG, q.responseOptionGroup); });
        }
        if (this.state.selectedFilterOptions.some(function (o) { return o.startsWith(constants_1.default.FILTER_PREFIX_LANGUAGE); })) {
            questions = questions.filter(function (q) { return q.languages.some(function (t) { return isSelected(constants_1.default.FILTER_PREFIX_LANGUAGE, t); }); });
        }
        if (this.state.selectedFilterOptions.some(function (o) { return o.startsWith(constants_1.default.FILTER_PREFIX_BENCHMARK); })) {
            questions = questions.filter(function (q) { return q.benchmarkIds.some(function (t) { return isSelected(constants_1.default.FILTER_PREFIX_BENCHMARK, t + ''); }); });
        }
        if (this.state.selectedFilterOptions.some(function (o) { return o.startsWith(constants_1.default.FILTER_PREFIX_QUESTIONTEMPLATE); })) {
            questions = questions.filter(function (q) {
                return (q.templateNames || []).some(function (t) { return isSelected(constants_1.default.FILTER_PREFIX_QUESTIONTEMPLATE, t + ''); });
            });
        }
        return this.SortQuestions(questions);
    };
    QuestionTable.prototype.SortQuestions = function (questions) {
        var _this = this;
        var sortHelper = new utilities_1.SortHelper();
        this.state.sortParams.forEach(function (p) {
            sortHelper.AddSortProperty(_this.GetPropertySelector(p.sortedBy), p.sortAsc);
        });
        return sortHelper.Sort(questions);
    };
    QuestionTable.prototype.GetPropertySelector = function (columnName) {
        var _this = this;
        switch (columnName) {
            case 'text':
                return function (q) { return q.text; };
            case 'code':
                return function (q) { return q.code; };
            case 'dimensions':
                return function (q) { return (q.dimensionNames || []).join(','); };
            case 'isSelected':
                return function (q) { return !(_this.IsCustomQuestionSelected(q) || _this.IsLibraryQuestionSelected(q)) + ''; };
            case 'isCustomQuestionSelected':
                return function (q) { return !_this.IsCustomQuestionSelected(q) + ''; };
            case 'isCustomQuestion':
                return function (q) { return (q.sourceType !== models_1.SourceType.Custom) + ''; };
            default:
                return function (q) { return ''; };
        }
    };
    QuestionTable.prototype.IsCustomQuestionSelected = function (question) {
        return (question.questionId && this.props.selectedCustomQuestionIds && this.props.selectedCustomQuestionIds.indexOf(question.questionId) > -1);
    };
    QuestionTable.prototype.IsLibraryQuestionSelected = function (question) {
        return question.questionVariationId && this.props.selectedQuestionVariationIds.indexOf(question.questionVariationId) > -1;
    };
    QuestionTable.prototype.IsQuestionRowDisabled = function (question) {
        var _a = this.props, disableWhenExceedingThreshold = _a.disableWhenExceedingThreshold, parentQuestionId = _a.parentQuestionId, selectionThreshold = _a.selectionThreshold, totalSelectedQuestions = _a.totalSelectedQuestions;
        // In most cases, selected questions should not be disabled.
        if (this.IsCustomQuestionSelected(question) || this.IsLibraryQuestionSelected(question)) {
            // Follow-up Questions can only be selected once and should be disabled when viewed under a different parent.
            if (parentQuestionId && question.parentQuestionId && parentQuestionId !== question.parentQuestionId) {
                return true;
            }
            return false;
        }
        var shouldEvaluateThreshold = disableWhenExceedingThreshold !== null && disableWhenExceedingThreshold !== void 0 ? disableWhenExceedingThreshold : false;
        var threshold = selectionThreshold !== null && selectionThreshold !== void 0 ? selectionThreshold : 0;
        if (shouldEvaluateThreshold) {
            // Don't disable unless a threshold has been set.
            if (threshold === 0) {
                return false;
            }
            // Don't disable if the threshold has not been met.
            if (threshold > totalSelectedQuestions) {
                return false;
            }
            return true;
        }
        return false;
    };
    QuestionTable.prototype.ToggleShowVariations = function (showVariations) {
        this.setState({ showVariations: showVariations });
        this.props.ShowAllVariations(showVariations);
    };
    return QuestionTable;
}(React.PureComponent));
exports.QuestionTable = QuestionTable;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
